// extracted by mini-css-extract-plugin
export default {"container":"register_container__ETW5a","remember":"register_remember__zfRbQ","buttons":"register_buttons__0dnLa"};